const {LG_WIDTH} = require("@main/helpers/const");

class ArticleAside {
    constructor(el) {
        this.el = el;
        this.parentNode = this.el.parentNode;
        this.targetNode = document.querySelector(".js-article-aside-container");
        this.addDocumentResizeObserver();
    }

    addDocumentResizeObserver() {
        if (this.targetNode) {
            this.resizeObserver = new ResizeObserver(this.onResizeWindow);
            this.resizeObserver.observe(document.body);
        }
    }

    onResizeWindow = ([entry]) => {
        if (entry.contentRect.width < LG_WIDTH && this.el.parentNode === this.targetNode) {
            this.parentNode.insertAdjacentElement("beforeend", this.el);
        } else if (entry.contentRect.width >= LG_WIDTH && this.el.parentNode === this.parentNode) {
            this.targetNode.insertAdjacentElement("beforeend", this.el);
        }
    };
}

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".js-article-aside").forEach((el) => new ArticleAside(el));
});
